import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Stagger, StaggerItem } from "@/components/common/Reveal";
import { credibility } from "@/config/site";

export default function CredibilityStrip() {
  return (
    <section className="border-y border-[#D9E0E4] bg-white" data-testid="credibility-strip" aria-label="What we do">
      <Stagger className="container-page grid grid-cols-2 lg:grid-cols-4 divide-x divide-[#D9E0E4]">
        {credibility.map((item) => (
          <StaggerItem key={item} className="py-6 lg:py-7 px-4 lg:px-6 flex items-center gap-3">
            <CheckCircle2 className="h-5 w-5 text-teal shrink-0" aria-hidden="true" />
            <span className="text-[13.5px] lg:text-[15px] font-medium text-navy leading-snug">{item}</span>
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
}
